import { startCase } from 'lodash';
import { Accordion, AccordionItem, AccordionHeader, AccordionContent, Icon, Typography, Table } from 'gd-design-library';
import { ProductEnrichmentDetails as ProductEnrichmentDetailsInterface, ProductSizeGuide } from '@services';

const GROUP_LABELS = {
  'coreMaterial': 'Materials & Care',
  'technicalSpecs': 'Product Specifications',
  'sizeFit': 'Size & Fit'
};

interface ProductEnrichmentDetailsProps {
  enrichmentDetails: ProductEnrichmentDetailsInterface;
  sizeGuide: ProductSizeGuide;
}

export const ProductEnrichmentDetails: React.FC<ProductEnrichmentDetailsProps> = ({
  enrichmentDetails,
  sizeGuide
}) => {
  const buildDetailValue = (value: string | number | boolean | unknown): string => {
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }

    return String(value);
  };

  return enrichmentDetails ? (
    <Accordion allowMultipleExpand>
      {Object.entries(enrichmentDetails).map(([ group, details ]) => (
        <AccordionItem key={ group } id={ group }>
          <AccordionHeader
            expandIcon={ <Icon name='keyboardArrowDown' size='xs' /> }
            style={ { margin: '0.5rem 0' } }
          >
            {GROUP_LABELS[group] || startCase(group)}
          </AccordionHeader>
          <AccordionContent>
            <div style={ { padding: '0 1rem 0.5rem 1rem' } }>
              {Object.entries(details).map(([ name, value ]) => (
                <Typography variant='p' key={ name }>
                  <span style={ { fontWeight: '500' } }>{startCase(name)}:</span> {buildDetailValue(value)}
                </Typography>
              ))}
              {group === 'sizeFit' && sizeGuide?.columns && (
                <Table
                  style={ { marginTop: '1rem' } }
                  columns={ sizeGuide.columns.map(column => ({ id: column, label: column, accessor: column })) }
                  data={ sizeGuide.rows.map(row => row.reduce(
                    (accumulator, cell, index) => ({
                      ...accumulator,
                      [sizeGuide.columns[index]]: cell
                    }),
                    { id: row[0] }
                  )) }
                />)
              }
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  ) : null;
};
